export const textMaxRewardsEnergy = 'You are full of energy! Go on a mission or go train!'
export const textMaxRewardsOther = `You have already used up all your energy, and you can't earn any more rewards.
Go rest to regain your energy!`